export class Constants {
  static FCM_NOTIFICATION_TOKEN_KEY = 'FCM_NOTIFICATION_TOKEN';
  static FCM_DEVICE_ID_KEY = 'FCM_DEVICE_ID';
  //#region Virtual moderated conference call - voxeet
  static CONFERENCE_STARTED = 'started';
  static CONFERENCE_ENDED = 'ended';
  static broadCastmuteAudioMessage = 'mute-all';
  static broadCastunmuteAudioMessage = 'unmute-all';
  static broadCastendConferenceMessage = 'conference-ended';
  static broadCastLeaveStageConferenceMessage = 'leave-stage';
  static broadCastJoinStageConferenceMessage = 'join-stage';
  static broadCastInviteOnStageConferenceMessage = 'inviteOnStage-';
  static broadCastRemoveFromStageConferenceMessage = 'removeFromStage-';
  static broadCastDeclineStageInviteConferenceMessage = 'declinedStageInvitation';
  static broadCastRecordingStarted = 'recording-started';
  static broadCastRecordingStopped = 'recording-stopped';
  static ConferenceListener = 'listener';
  static ConferenceOnStage = 'onstage';
  static ConferenceLeft = 'Left';
  static AUdienceUserType = 'audience';
  static BroadCastRejectedFromMobile = 'unableToJoinStage';
  static ROLE_OWNER = 'owner';
  //#endregion
}
